/* ============================================================
   arthene — Werkseite

   Ursprünglich portiert aus mockups/produktseite/produktseite.js,
   erweitert um die Teile, die Entwurf 10 („Reinzeichnung“) zusätzlich
   braucht: Blätterpfeile an der Bühne, Teilen-Menü, Drucken, das
   Werkband über der Seite und das Ablegen ohne Neuladen.

   Acht unabhängige Teile, jeder prüft selbst, ob sein Markup da ist:

     1. Filmstreifen — Vorschaubild wählen
     2. Blätterpfeile an der Bühne
     3. Lightbox — Bild groß ansehen
     4. Teilen-Menü und Drucken
     5. Werkband — blättern, nachladen, geöffnetes Werk mittig
     6. Feste Kaufleiste unten, sobald der Kaufblock aus dem Bild ist
     7. In den Warenkorb ohne Neuladen
     8. Porträt entfernen, wenn es das Bild nicht gibt
     9. „Weitere Werke": das gerade offene Werk herausnehmen
    10. Sanftes Einblenden der Abschnitte

   Kasse und Warenkorbrechnung bleiben unangetastet: der Kaufknopf ist
   ein normales Produktformular an Shopify. Teil 7 fängt es nur ab und
   schickt dieselben Daten an /cart/add.js — ohne JavaScript (oder wenn
   etwas schiefgeht) greift das Formular ganz normal.
   ============================================================ */
(function () {
  'use strict';

  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Shopify setzt window.Shopify.routes.root über content_for_header.
     Der Rückfall hält die Datei auch außerhalb der Storefront lauffähig. */
  function wurzelPfad() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function init() {
    var seite = document.querySelector('.werkseite');
    if (!seite || seite.dataset.artheneWerkReady === '1') return;
    seite.dataset.artheneWerkReady = '1';

    /* ---------- 1. Filmstreifen ---------- */
    var grossbild = seite.querySelector('[data-buehne-bild]');
    var bu = seite.querySelector('[data-buehne-bu]');
    var zaehler = seite.querySelector('[data-buehne-zaehler]');
    var filme = Array.prototype.slice.call(seite.querySelectorAll('[data-vorschau]'));

    function jetztAktiv() {
      for (var i = 0; i < filme.length; i++) {
        if (filme[i].classList.contains('ist-aktiv')) return i;
      }
      return 0;
    }

    function waehle(knopf) {
      if (!grossbild || !knopf) return;
      var voll = knopf.getAttribute('data-voll');
      var text = knopf.getAttribute('data-bu') || '';

      if (ruhig) {
        /* Das Bild hat ein srcset für die Bühne — beim Wechsel muss es
           weg, sonst zeigt der Browser weiter die alte Auflösung. */
        grossbild.removeAttribute('srcset');
        grossbild.src = voll;
        grossbild.alt = text || grossbild.alt;
      } else {
        /* Kurz ausblenden, damit der Wechsel nicht springt. */
        grossbild.style.opacity = '0';
        var neu = new Image();
        neu.onload = neu.onerror = function () {
          grossbild.removeAttribute('srcset');
          grossbild.src = voll;
          grossbild.alt = text || grossbild.alt;
          grossbild.style.opacity = '';
        };
        neu.src = voll;
      }

      if (bu) bu.textContent = text;
      filme.forEach(function (f, i) {
        var aktiv = f === knopf;
        f.classList.toggle('ist-aktiv', aktiv);
        f.setAttribute('aria-selected', aktiv ? 'true' : 'false');
        f.tabIndex = aktiv ? 0 : -1;
        if (aktiv && zaehler) {
          zaehler.textContent = String(i + 1).padStart(2, '0') + ' / ' +
            String(filme.length).padStart(2, '0');
        }
      });
    }

    filme.forEach(function (f) {
      f.addEventListener('click', function () { waehle(f); });
    });

    /* Pfeiltasten im Filmstreifen — sonst ist eine Tab-Liste nur mit der
       Maus bedienbar. */
    var spur = seite.querySelector('[role="tablist"]');
    if (spur) {
      spur.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var jetzt = jetztAktiv();
        var ziel = e.key === 'ArrowRight' ? jetzt + 1 : jetzt - 1;
        if (ziel < 0) ziel = filme.length - 1;
        if (ziel >= filme.length) ziel = 0;
        e.preventDefault();
        waehle(filme[ziel]);
        filme[ziel].focus();
      });
    }

    /* ---------- 2. Blätterpfeile an der Bühne ---------- */
    function blaettern(richtung) {
      if (!filme.length) return;
      var ziel = (jetztAktiv() + richtung + filme.length) % filme.length;
      waehle(filme[ziel]);
    }
    var buehneVor = seite.querySelector('[data-buehne-vor]');
    var buehneZurueck = seite.querySelector('[data-buehne-zurueck]');
    if (buehneVor) buehneVor.addEventListener('click', function () { blaettern(1); });
    if (buehneZurueck) buehneZurueck.addEventListener('click', function () { blaettern(-1); });

    /* ---------- 3. Lightbox ----------
       Sie hängt außerhalb von <main>, damit sie über allem liegt —
       deshalb hier document statt seite. */
    var box = document.querySelector('[data-lightbox]');
    if (box && grossbild) {
      var boxBild = box.querySelector('img');
      var boxBu = box.querySelector('[data-lightbox-bu]');
      var zuletztFokus = null;

      var oeffnen = function () {
        boxBild.src = grossbild.currentSrc || grossbild.src;
        boxBild.alt = grossbild.alt;
        if (boxBu) boxBu.textContent = bu ? bu.textContent : '';
        zuletztFokus = document.activeElement;
        box.classList.add('is-offen');
        box.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        var zu = box.querySelector('[data-lightbox-zu]');
        if (zu) zu.focus();
      };
      var schliessen = function () {
        box.classList.remove('is-offen');
        box.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (zuletztFokus && zuletztFokus.focus) zuletztFokus.focus();
      };

      seite.querySelectorAll('[data-zoom]').forEach(function (el) {
        el.addEventListener('click', oeffnen);
      });
      box.addEventListener('click', function (e) {
        if (e.target === box || e.target === boxBild || e.target.closest('[data-lightbox-zu]')) schliessen();
      });
      document.addEventListener('keydown', function (e) {
        if (!box.classList.contains('is-offen')) return;
        if (e.key === 'Escape') { schliessen(); return; }
        /* Im Großbild weiterblättern — und das Großbild mitziehen. */
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          blaettern(e.key === 'ArrowRight' ? 1 : -1);
          var k = filme[jetztAktiv()];
          if (k) {
            boxBild.src = k.getAttribute('data-voll');
            if (boxBu) boxBu.textContent = k.getAttribute('data-bu') || '';
          }
        }
      });
    }

    /* ---------- 4. Teilen-Menü und Drucken ---------- */
    var teilen = seite.querySelector('[data-teilen]');
    if (teilen) {
      var teilenKnopf = teilen.querySelector('[data-teilen-knopf]');
      var teilenMenue = teilen.querySelector('[data-teilen-menue]');
      if (teilenKnopf && teilenMenue) {
        var setzeTeilen = function (offen) {
          teilenKnopf.setAttribute('aria-expanded', String(offen));
          teilenMenue.hidden = !offen;
        };
        teilenKnopf.addEventListener('click', function (e) {
          e.stopPropagation();
          setzeTeilen(teilenMenue.hidden);
        });
        document.addEventListener('click', function (e) {
          if (!teilenMenue.hidden && !teilen.contains(e.target)) setzeTeilen(false);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !teilenMenue.hidden) { setzeTeilen(false); teilenKnopf.focus(); }
        });
      }
    }
    var drucker = seite.querySelector('[data-drucken]');
    if (drucker) drucker.addEventListener('click', function () { window.print(); });

    /* ---------- 5. Werkband ----------
       Gibt es zu der Person eine Kategorie, steht die Reihe schon da
       (data-fertig). Sonst holen wir sie über Shopifys Anbieter-Adresse
       nach — Liquid kann Produkte nicht nach „Anbieter“ durchsuchen. */
    var band = seite.querySelector('[data-werkband]');
    if (band) {
      var reihe = band.querySelector('[data-werkband-reihe]');

      var mitteRollen = function () {
        var offen = reihe.querySelector('.ist-offen');
        if (offen) reihe.scrollLeft = Math.max(0, offen.offsetLeft - (reihe.clientWidth - offen.offsetWidth) / 2);
      };
      var schritt = function () { return Math.max(reihe.clientWidth * 0.7, 160); };
      var rolle = function (richtung) {
        reihe.scrollBy({ left: richtung * schritt(), behavior: ruhig ? 'auto' : 'smooth' });
      };
      var bZurueck = band.querySelector('[data-werkband-zurueck]');
      var bVor = band.querySelector('[data-werkband-vor]');
      if (bZurueck) bZurueck.addEventListener('click', function () { rolle(-1); });
      if (bVor) bVor.addEventListener('click', function () { rolle(1); });

      /* Weniger als zwei Werke sind kein Band — dann lieber nichts. */
      var aufraeumen = function () {
        if (reihe.children.length < 2) band.remove();
        else mitteRollen();
      };

      if (band.dataset.fertig === '1') {
        aufraeumen();
      } else if (window.fetch && band.dataset.name) {
        var adresse = wurzelPfad() + 'collections/vendors?q=' +
          encodeURIComponent(band.dataset.name) + '&view=werkband';
        fetch(adresse, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (a) { return a.ok ? a.text() : Promise.reject(a.status); })
          .then(function (html) {
            reihe.innerHTML = html;
            /* Die nachgeladene Reihe weiß nicht, welches Werk offen ist —
               das entscheidet sich hier an der Adresse. */
            var hier = window.location.pathname.split('?')[0];
            reihe.querySelectorAll('a').forEach(function (a) {
              if (a.getAttribute('href').split('?')[0] !== hier) return;
              a.parentNode.classList.add('ist-offen');
              a.setAttribute('aria-current', 'page');
            });
            aufraeumen();
          })
          .catch(function () { band.remove(); });
      } else {
        band.remove();
      }
    }

    /* ---------- 6. Feste Kaufleiste ----------
       Auch sie hängt außerhalb von <main>. */
    var leiste = document.querySelector('[data-kaufleiste]');
    var kaufblock = seite.querySelector('[data-kaufblock]');
    if (leiste && kaufblock && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          var da = !e.isIntersecting && e.boundingClientRect.top < 0;
          leiste.classList.toggle('ist-da', da);
          /* Der Seitenkörper bekommt Platz unter der Leiste, sonst
             verschwinden die letzten Zeilen der Fußzeile dahinter. */
          document.body.classList.toggle('hat-kaufleiste', da);
          if (da) {
            document.body.style.setProperty('--kaufleiste-h', leiste.offsetHeight + 'px');
          }
        });
      }, { threshold: 0 }).observe(kaufblock);
    }

    /* ---------- 7. In den Warenkorb ohne Neuladen ---------- */
    var melder = seite.querySelector('[data-kauf-melder]');
    function melde(text) { if (melder) melder.textContent = text || ''; }

    /* Die uebersetzten Texte haengen als data-Attribute an eben diesem Absatz
       (sections/arthene-werk.liquid) — eine .js-Datei rendert kein Liquid und
       kennt die Sprache nicht. Der deutsche Rueckfall greift nur, wenn ein
       Attribut einmal fehlt. */
    function kauftext(name, rueckfall) {
      var wert = melder && melder.getAttribute('data-' + name);
      return wert || rueckfall;
    }

    function zaehlerAuffrischen() {
      return fetch(wurzelPfad() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (a) { return a.json(); })
        .then(function (korb) {
          document.querySelectorAll('[data-arthene-cart-count]').forEach(function (el) {
            el.textContent = korb.item_count;
            /* Liquid haengt dem Zaehler beim Aufbau der Seite ein hidden an,
               solange der Korb leer ist (arthene-masthead.liquid), und
               .cart-link__count[hidden] blendet ihn aus. Ohne das Entfernen
               blieb die Ziffer nach dem ersten Ablegen unsichtbar. */
            if (korb.item_count === 0) {
              el.setAttribute('hidden', '');
            } else {
              el.removeAttribute('hidden');
            }
          });
        })
        .catch(function () { /* Der Zähler ist Beiwerk — Fehler nicht anzeigen. */ });
    }

    /* ---------- 7a. Variantenwahl auf die klebende Leiste uebertragen ----------

       Die Wahl steht nur im oberen Formular (<select name="id">). Die Leiste am
       unteren Rand schickt ein festes verstecktes Feld mit der zuerst
       verfuegbaren Variante — wer oben umschaltete und unten kaufte, legte
       damit die falsche Variante in den Warenkorb. Der Preis in der Leiste
       zeigte ebenfalls weiter den alten Wert.

       Der Preis kommt aus der Beschriftung der gewaehlten Option
       („Titel — 1.250 €"): so steht dort dieselbe, von Liquid korrekt
       formatierte Zahl, ohne sie im Skript nachzubauen. */
    var variantenwahl = document.getElementById('werk-variante');
    if (variantenwahl) {
      variantenwahl.addEventListener('change', function () {
        var wert = variantenwahl.value;
        document.querySelectorAll('[data-kaufform] input[name="id"]').forEach(function (feld) {
          feld.value = wert;
        });

        var preisEl = document.querySelector('.kaufleiste__preis');
        var option = variantenwahl.options[variantenwahl.selectedIndex];
        if (preisEl && option) {
          var teile = option.textContent.split('—');
          if (teile.length > 1) preisEl.textContent = teile[teile.length - 1].trim();
        }
      });
    }

    document.querySelectorAll('[data-kaufform]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;              /* Rückfall: normales Formular */
        e.preventDefault();
        var knopf = form.querySelector('[data-kaufen]');
        /* Das Theme legt über jeden .btn einen Buchstaben-Wischer
           (arthene.js baut dafür verschachtelte <span> ein). textContent
           würde dieses Gerüst zerstören und beim Zurücksetzen den doppelten
           Buchstabensalat als Klartext hinterlassen — deshalb innerHTML
           merken und am Ende unverändert zurückgeben. */
        var altHTML = knopf ? knopf.innerHTML : '';
        if (knopf) { knopf.disabled = true; knopf.textContent = kauftext('abgelegt', 'Wird abgelegt …'); }
        melde('');

        fetch(wurzelPfad() + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (a) {
            return a.json().then(function (daten) { return { ok: a.ok, daten: daten }; });
          })
          .then(function (r) {
            if (!r.ok) throw new Error(r.daten.description || r.daten.message || '');
            if (knopf) knopf.textContent = kauftext('knopf-erfolg', 'Im Warenkorb');
            melde(kauftext('erfolg', 'Das Werk liegt im Warenkorb.'));
            return zaehlerAuffrischen();
          })
          .catch(function (fehler) {
            /* Ehrlich bleiben: der Knopf darf nicht „erledigt“ zeigen,
               wenn nichts abgelegt wurde. */
            if (knopf) knopf.innerHTML = altHTML;
            melde(fehler.message || kauftext('fehler', 'Das Werk konnte nicht abgelegt werden. Bitte erneut versuchen.'));
          })
          .then(function () {
            if (!knopf) return;
            window.setTimeout(function () {
              knopf.disabled = false;
              knopf.innerHTML = altHTML;
            }, 2400);
          });
      });
    });

    /* ---------- 8. Porträt, das es nicht gibt ----------
       Zu gut 130 Künstlern liegt kein Porträt im Theme. Liquid kann das
       nicht prüfen, der Browser schon: lädt das Bild nicht, fliegt es
       raus und der Text rückt auf. */
    var portraet = seite.querySelector('[data-portraet]');
    if (portraet) {
      var wegDamit = function () {
        var karte = portraet.closest('[data-kuenstlerkarte]');
        portraet.remove();
        if (karte) karte.classList.add('ohne-bild');
      };
      portraet.addEventListener('error', wegDamit);
      /* Bereits fehlgeschlagen, bevor der Zuhörer stand. */
      if (portraet.complete && portraet.naturalWidth === 0) wegDamit();
    }

    /* ---------- 9. „Weitere Werke": das offene Werk raus ----------
       Das Raster kommt aus dem gemeinsamen Snippet der Künstlerseite und
       kennt das gerade geöffnete Werk nicht. Es kommt außerdem oft erst
       nachgeladen an, deshalb der Beobachter. */
    var kwerke = seite.querySelector('[data-kuenstler-werke]');
    if (kwerke) {
      var hierPfad = window.location.pathname.split('?')[0];
      var putzen = function () {
        var raster = kwerke.querySelector('.kwerke__raster');
        if (!raster || raster.dataset.wartet === '1') return;
        raster.querySelectorAll('.kwerk__link').forEach(function (a) {
          var ziel = (a.getAttribute('href') || '').split('?')[0];
          if (ziel !== hierPfad) return;
          var kachel = a.closest('.kwerk');
          if (kachel) kachel.remove();
        });
        /* Bleibt nichts übrig, verschwindet das Raster — der Knopf in die
           gefilterte Galerie bleibt stehen. */
        if (!raster.querySelector('.kwerk')) kwerke.classList.add('is-leer');
      };
      putzen();
      if ('MutationObserver' in window) {
        new MutationObserver(putzen).observe(kwerke, { childList: true, subtree: true });
      }
    }

    /* ---------- 10. Einblenden ---------- */
    var auf = Array.prototype.slice.call(seite.querySelectorAll('.auf'));
    if (auf.length && !ruhig && 'IntersectionObserver' in window) {
      var beobachter = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('ist-da');
          beobachter.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -12% 0px' });
      auf.forEach(function (el) { beobachter.observe(el); });
    } else {
      auf.forEach(function (el) { el.classList.add('ist-da'); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
